import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={14}
    height={16}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2485 0.985352H9.00444C8.59182 0.985352 8.25291 1.32426 8.25291 1.73689C8.25291 2.14951 8.59182 2.48842 9.00444 2.48842L11.4212 2.48852L4.39193 9.53255C4.09722 9.82726 4.09722 10.2989 4.39193 10.5936C4.53933 10.741 4.73084 10.8146 4.92244 10.8146C5.11404 10.8146 5.30556 10.7409 5.45295 10.5936L12.497 3.56428V5.98107C12.497 6.39369 12.8359 6.7326 13.2485 6.7326C13.6611 6.7326 14.0001 6.39369 14.0001 5.98107L14.0002 1.73696C14.0002 1.32434 13.6612 0.985428 13.2486 0.985428L13.2485 0.985352Z"
      fill="#666666"
    />
    <path
      d="M11.3029 7.95571C10.8903 7.95571 10.5513 8.29463 10.5513 8.70725V11.7282C10.5513 12.7009 9.75562 13.4819 8.79767 13.4819H3.2715C2.29886 13.4819 1.51783 12.6862 1.51783 11.7282V6.20205C1.51783 5.22941 2.31355 4.44838 3.2715 4.44838H6.29247C6.70509 4.44838 7.04401 4.10947 7.04401 3.69685C7.04401 3.28422 6.70509 2.94531 6.29247 2.94531H3.2715C1.47365 2.94531 0 4.40425 0 6.21681V11.743C0 13.5408 1.45894 15.0145 3.2715 15.0145H8.79767C10.5955 15.0145 12.0692 13.5555 12.0692 11.743V8.70727C12.0544 8.29465 11.7155 7.95566 11.3028 7.95566L11.3029 7.95571Z"
      fill="#666666"
    />
  </svg>
);
export default SVGComponent;
